export default {
  name: 'Journal de bord',
  icon: 'menu_book',
  noItems:
    "Il n'y a pas d'évènements en relation avec les filtres sélectionnés",
  fields: {
    entry_datetime: 'Date',
    resume: 'Description',
    author_name: 'Auteur',
    date_string: 'Date',
    payload: 'Payload',
    document_exists: 'Documents présents',
  },
  documents: {
    icon: 'mdi-file',
    name: 'Documents',
  },
};
